export const GET_APP_INIT_DATA = 'GET_ACCOUNT_INFO';
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO';

export const UPDATE_ACCOUNT_INFO='UPDATE_ACCOUNT_INFO';
export const UPDATE_INAPPNOTICE='UPDATE_INAPPNOTICE';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const SET_CLIENT = 'SET_CLIENT';

export const SET_ROUTE_BEFORE_BLOCK = 'SET_ROUTE_BEFORE_BLOCK';